import React, { SyntheticEvent, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation, useBaseAppConfig } from '@core/hooks';
import { User, FetchStatus } from '../../types';
import { signInUser } from '../../redux/actions';

// devExtreme
import dxPopup from 'devextreme/ui/popup';
import Form, { ButtonItem, ButtonOptions, Item } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';

// components
import FormInputs from './FormInputs/FormInputs';
import FormFooter from './FormFooter/FormFooter';

const LoginForm = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [popupVisible, setPopupVisible] = useState(false);
  const formData = useRef({});
  const dispatch = useDispatch();
  const { fetchStatus, data } = useSelector(({ user }: { user: User }) => ({
    fetchStatus: user.fetchStatus,
    data: user.data
  }));

  const { t } = useTranslation();

  const config = useBaseAppConfig();

  const onSubmit = (e: SyntheticEvent) => {
    e.preventDefault();

    dispatch(
      signInUser({
        login,
        password
      })
    );
  };

  const handleOnShowing = (
    component: dxPopup | undefined,
    setVisible: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // eslint-disable-next-line no-underscore-dangle
    const saveButton = component?.content().querySelector('.dx-icon-close');

    if (!saveButton) return;

    saveButton.addEventListener('onclick', () => {
      setVisible(false);
    });
  };

  const showError = () => {
    let errMsg = t('Err_msg_default');

    if (data.errorStatus === 401) {
      errMsg = t('Err_msg_unauthorized');
    }

    return (
      <>
        <p>{errMsg}</p>
      </>
    );
  };

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <Form
        formData={formData.current}
        disabled={fetchStatus === FetchStatus.FETCHING}
      >
        <Item>
          <FormInputs setLogin={setLogin} setPassword={setPassword} />
        </Item>
        <Item>
          <div className="login-form__error">
            {fetchStatus === FetchStatus.ERROR ? showError() : <p />}
          </div>
        </Item>
        <ButtonItem>
          <ButtonOptions width="100%" type="default" useSubmitBehavior>
            <span className="dx-button-text">{t('Zaloguj')}</span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <FormFooter setPopupVisible={setPopupVisible} />
      <Popup
        onShowing={(e) => handleOnShowing(e.component, setPopupVisible)}
        title="Adres API: "
        visible={popupVisible}
        width={270}
        height={120}
        onHiding={() => setPopupVisible(false)}
      >
        <p style={{ textAlign: 'center' }}> {config.authApiUrl}</p>
      </Popup>
    </form>
  );
};

export default LoginForm;
